<template>
  <vis-inner-layout>
    <vis-loading size="md" v-if="loading" logo />
    <vis-error size="md" v-else-if="error" with-default logo :state="state" />
    <div v-else class="ba-flex ba-flex-col ba-items-center ba-m-auto ba-p-4 ba-text-gray-200">
      <vis-error size="md" logo :state="state">Произошла ошибка при авторизации</vis-error>
      <a
        v-if="canBackUri"
        href="#"
        class="ba-text-link ba-underline hover:ba-no-underline"
        @click.prevent="backRedirect"
      >Вернуться в личный кабинет</a>
      <router-link
        v-else
        :to="{ name: 'login', query: { state } }"
        class="ba-text-link ba-underline hover:ba-no-underline"
      >
        <span>Вернуться на авторизацию</span>
      </router-link>
    </div>
  </vis-inner-layout>
</template>

<script>
import VisInnerLayout from "./vis-inner-layout";
import { errorMixin } from "@ba/visary-account-common-vue";

export default {
  name: "vis-page-error",
  components: {
    VisInnerLayout
  },
  mixins: [errorMixin]
};
</script>
